import { IPreloadedState } from 'shared/types/redux';

export const selectNearbyHousesInfo = (state: IPreloadedState) => state.marketTrends.nearbyHousesInfo;
